import * as Api from './Api';

export interface None {
  status: 'none';
  code: string;
}

export interface Loading {
  status: 'loading';
  code: string;
  items: Api.VoucherBasketItemDm[];
  isUserInput?: boolean;
}

export interface Valid {
  status: 'valid';
  code: string;
  items: Api.VoucherBasketItemDm[];
  isUserInput?: boolean;
}

export const Default: None = {
  status: 'none',
  code: '',
};

export type States = None | Loading | Valid;
